/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useEffect, useState } from "react";

const useAgent = () => {
	const [currentAgent, setCurrentAgent] = useState(null);

	useEffect(() => {
		const agentSubscription = window.connect?.agent(async (agent) => {
			setCurrentAgent(agent);
		});
		return () => {
			agentSubscription.unsubscribe();
		};
	}, []);

	return currentAgent;
};

export default useAgent;
